<div class="content-heading">
  <div class="header-Container">
    <h3>Archivos Adjuntos</h3>
    <small>{{subtitulo}}</small>
  </div>
</div>

<div class="form-container">
  <div class="container-fluid">
    <div class="row">
      <!-- Grid de Archivos -->
      <div class="col-md-12 col-xs-12">
        <app-ceq-table 
          #CeqGrid
          [gridAdditionalOptions]="gridOptions" 
          [columnDef]="columnDefs" 
          (apiEmitter)="ListEmiter($event)">
        </app-ceq-table>
      </div>

      <!-- Acciones: Carga y Volver -->
      <div class="col-sm-12">
        <br>
        <aph-custom-buttons 
          *ngIf="canCreate"
          preset="save" 
          label="Nuevo archivo adjunto..." 
          [loading]="Working"
          (btnClick)="waveLoad.click()"
          [disabled]="Working">
        </aph-custom-buttons>

        &nbsp;&nbsp;&nbsp;

        <input type="file" (change)="onWaveLoadSelect($event.target.files)" #waveLoad hidden
          accept=".xls,.xlsx,.doc,.docx,.pdf,.png,.xml,.txt,.jpg,.msg,.jpeg,.bmp,.gif,.eml" id="waveLoad" name="waveLoad" />

        <aph-custom-buttons 
          preset="exit" 
          label="Volver" 
          (btnClick)="btnCancelOnClick()">
        </aph-custom-buttons>
      </div>

      <br>

      <!-- Panel de Previsualización (Imagen/Texto) -->
      <div class="col-sm-12" [hidden]="!isImage && !isText">
        <br>
        <div style="text-align: center; border: 2px solid black;">
          <h2 style="color: black;">{{title}}</h2><br>
          <img [src]="img" class="image" [alt]="title" style="align-self: center; border: 20px;" [hidden]="isText">
          <h3 [hidden]="isImage">{{contentString}}</h3>
        </div>
      </div>

      <!-- Panel de Previsualización (PDF/Iframe) -->
      <div class="col-12" [hidden]="!showIframe">
        <section class="pb-4">
          <div class="border rounded-5">
            <section class="p-4 text-center pb-4 w-100">
              <div class="embed-responsive embed-responsive-16by9">
                <iframe class="embed-responsive-item" [src]="sanitizedUrl" height="600"></iframe>
              </div>
            </section>
          </div>
        </section>
      </div>
    </div>
  </div>
</div>